import { Validators } from "@angular/forms";
import { FormField } from "./form-field.model";

export const LEARNER_FORM: { [key: string]: FormField } = {
    learnerId: {
        id: 'learnerId',
        type: 'hidden',
        name: 'learnerId',
        label: 'ID',
        placeholder: "ID",
        value: '',
        data: [],
        validators: [],
        errorMessages: {}
    },
    name: {
        id: 'name',
        type: 'text',
        name: 'name',
        label: 'Nome',
        placeholder: "Nessun discente assegnato",
        value: '',
        data: [],
        validators: [Validators.required],
        errorMessages: {
            required: "Inserire il nome del discente."
        }
    },
    surname: {
        id: 'surname',
        type: 'text',
        name: 'surname',
        label: 'Cognome',
        placeholder: "Nessun discente assegnato",
        value: '',
        data: [],
        validators: [Validators.required],
        errorMessages: {
            required: "Inserire il cognome del discente."
        }
    },
    email: {
        id: 'email',
        type: 'email',
        name: 'email',
        label: 'Email',
        placeholder: "Nessun discente assegnato",
        value: '',
        data: [],
        validators: [Validators.required, Validators.email],
        errorMessages: {
            required: "Inserire l'email del discente.",
            email: "Inserire un'email valida."
        }
    },
    fiscalCode: {
        id: 'fiscalCode',
        type: 'text',
        name: 'fiscalCode',
        label: 'Codice Fiscale',
        placeholder: "Nessun discente assegnato",
        value: '',
        data: [],
        validators: [Validators.required],
        errorMessages: {
            required: "Inserire il codice fiscale del discente."
        }
    },
    birthDate: {
        id: 'birthDate',
        type: 'date',
        name: 'birthDate',
        label: 'Data di Nascita',
        placeholder: "Nessun discente assegnato",
        value: '',
        data: [],
        validators: [Validators.required],
        errorMessages: {
            required: "Inserire la data di nascita del discente."
        }
    },
    birthPlaceId: {
        id: 'birthPlaceId',
        type: 'ng-select',
        name: 'birthPlaceId',
        label: 'Luogo di Nascita',
        placeholder: "Nessun discente assegnato",
        value: null,
        data: [],
        validators: [Validators.required],
        errorMessages: {
            required: "Inserire il luogo di nascita del discente."
        }
    }
};
